module.exports = __webpack_public_path__ + "static/img/theme_03.98f3b79f.png";